import {
    CurrentZoneTemplateAssignment,
    CurrentZoneTemplateDescriptor,
    CurrentZoneTemplateData, CurrentZoneTemplateType, CurrentZoneLevel
} from "./zone-template.class";
import {SHELL_PROTOCOL_OPERATIONS_NS} from "../../shell-communication/operations/shell-protocol-namespace.const";
import {ProtocolQuery} from "../../service-model/protocol-query.interface";
import {ProtocolCommand} from "../../service-model/protocol-command.interface";

export class GetAllCurrentZoneTemplates implements ProtocolQuery {

    constructor() {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetAllCurrentZoneTemplates`;
    }
}

export interface GetAllCurrentZoneLevelsTemplatesReply {
    templates: CurrentZoneTemplateDescriptor[];
}

//

export class GetCurrentZoneTemplateData implements ProtocolQuery {
    constructor(public readonly templateId: string) {
    }
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetCurrentZoneTemplateData`;
    }
}

export interface GetCurrentZoneLevelsTemplateDataReply {
    data: CurrentZoneTemplateData;
}

//

export class GetCurrentZoneTemplatesByType implements ProtocolQuery {

    constructor(public readonly templateType: CurrentZoneTemplateType) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetCurrentZoneTemplatesByType`;
    }
}

export interface GetCurrentZoneTemplatesByTypeReply {
    templates: CurrentZoneTemplateDescriptor[];
}

//

export class SaveCurrentZoneTemplate implements ProtocolCommand {
    constructor(public readonly template: CurrentZoneTemplateDescriptor,
                public readonly data: CurrentZoneTemplateData) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SaveCurrentZoneTemplate`;
    }
}

//

export class DeleteCurrentZoneTemplate implements ProtocolCommand {
    constructor(public readonly templateId: string) {
    }
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.DeleteCurrentZoneTemplate`;
    }
}

//

export class GetPortfolioCurrentZoneData implements ProtocolQuery {
    constructor(public readonly portfolioId: string) {}
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetPortfolioCurrentZoneData`;
    }
}

export interface GetPortfolioCurrentZoneDataReply {
    portfolioId: string;
    type: CurrentZoneTemplateType;
    currentZone?: number;
    levels: CurrentZoneLevel[];
}

//

export class SetCurrentZoneLevel implements ProtocolCommand {
    constructor(public readonly portfolioId: string, public readonly level: number) {}
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SetCurrentZoneLevel`;
    }
}

/**
 * Owner ruling 2026-09-15: a super user sets a Type 3 portfolio's zone by hand. Its own command
 * (Type 2 and Type 3 share nothing); the level must be a line of the template's grid.
 */
export class SetCurrentZoneLevel3 implements ProtocolCommand {
    constructor(public readonly portfolioId: string, public readonly level: number) {}
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SetCurrentZoneLevel3`;
    }
}

//

/**
 * CR-20260916-002: a SCOPED save. `portfolioIds` names every portfolio the Assign Templates
 * dialog listed (ticked or not); the shell rewrites only those portfolios' rows and keeps the
 * rest. Without it, one super user's save erased every other super user's assignments, because
 * the store is one row for everyone and each dialog sees only its own users.
 */
export class SetAssignmentData implements ProtocolCommand {
    constructor(
        public readonly assignments: CurrentZoneTemplateAssignment[],
        public readonly portfolioIds: string[]
    ) {}
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SetAssignmentData`;
    }
}

export class GetAssignmentData implements ProtocolQuery {
    constructor() {
    }
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetAssignmentData`;
    }
}

export class GetAssignmentDataReply {
    assignments: CurrentZoneTemplateAssignment[];
}

//
// CR-20260904-001, Zones Z5/Z6. The per-trader zone TYPE grant (BR-Z1).
// Not to be confused with the per-portfolio template ASSIGNMENT above: the assignment says which
// ladder a portfolio uses, the grant says which types a user may work with in the editor.
//

/**
 * The stored grant values: one type, or every type. Owner ruling 2026-09-13 cut the list to
 * these four; the former 'Both' (Type 1 + Type 2) and 'Type 2 + 3' are migrated to 'All' by the
 * backend on read, so no such value ever reaches the browser.
 */
export type ZoneTypeGrantValue = CurrentZoneTemplateType | 'All';

export interface ZoneTypeGrant {
    userId: string;
    zoneType: ZoneTypeGrantValue;
}

export class GetZoneTypeGrants implements ProtocolQuery {
    constructor() {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetZoneTypeGrants`;
    }
}

export interface GetZoneTypeGrantsReply {
    grants: ZoneTypeGrant[];

    /** Whether the CALLER is a super user. Nobody else's privilege level is sent - by design. */
    isSuperUser: boolean;
}

export class SetZoneTypeGrant implements ProtocolCommand {
    constructor(public readonly userId: string,
                public readonly zoneType: ZoneTypeGrantValue | null) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SetZoneTypeGrant`;
    }
}
